import {
    CAMPUS_BERKELEY,
    CAMPUS_DAVIS,
    CAMPUS_IRVINE,
    CAMPUS_MERCED,
    CAMPUS_RIVERSIDE,
    CAMPUS_SAN_DIEGO,
    CAMPUS_SANTA_BARBARA,
    CAMPUS_SANTA_CRUZ,
    CAMPUS_UCLA,
    COSTS_DIRECT_CAMPUS_FEES,
    COSTS_DIRECT_HEALTH_INSURANCE,
    COSTS_DIRECT_HOUSING_AND_MEALS,
    COSTS_DIRECT_TUITION,
    COSTS_INDIRECT_BOOKS_AND_SUPPLIES,
    COSTS_INDIRECT_HOUSING_AND_MEALS,
    COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION,
    HOUSING_COMMUTER,
    HOUSING_OFF_CAMPUS,
    HOUSING_ON_CAMPUS,
    NON_RESIDENT_SCHOLARSHIP,
    NON_RESIDENT_SCHOLARSHIP_HIGH,
    NON_RESIDENT_SCHOLARSHIP_LOW,
    RESIDENCY_CALIFORNIA,
    RESIDENCY_OTHER,
    SELF_HELP,
    SELF_HELP_DEBT_FREE,
    SELF_HELP_RANGE_HIGH,
    SELF_HELP_RANGE_LOW
} from "./MAGIC_NUMBERS";

export const ATTENDANCE_COSTS = {
    [RESIDENCY_CALIFORNIA]: {
        [CAMPUS_BERKELEY]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 9500,
                [SELF_HELP_RANGE_HIGH]: 9500
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2086,
                [HOUSING_OFF_CAMPUS]: 2086,
                [HOUSING_COMMUTER]: 2086
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 21508,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0,
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 4050,
                [HOUSING_OFF_CAMPUS]: 4050,
                [HOUSING_COMMUTER]: 4050
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18422,
                [HOUSING_COMMUTER]: 7732
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1131,
                [HOUSING_OFF_CAMPUS]: 1131,
                [HOUSING_COMMUTER]: 1131
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3326,
                [HOUSING_OFF_CAMPUS]: 3800,
                [HOUSING_COMMUTER]: 5260
            }
        },
        [CAMPUS_DAVIS]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 11000,
                [SELF_HELP_RANGE_HIGH]: 13000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2321,
                [HOUSING_OFF_CAMPUS]: 2321,
                [HOUSING_COMMUTER]: 2321
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19785,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3741,
                [HOUSING_OFF_CAMPUS]: 3741,
                [HOUSING_COMMUTER]: 3741
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 14745,
                [HOUSING_COMMUTER]: 8020
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1386,
                [HOUSING_OFF_CAMPUS]: 1386,
                [HOUSING_COMMUTER]: 1386
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 2977,
                [HOUSING_OFF_CAMPUS]: 3615,
                [HOUSING_COMMUTER]: 4985
            }
        },
        [CAMPUS_IRVINE]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 10500,
                [SELF_HELP_RANGE_HIGH]: 11000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1274,
                [HOUSING_OFF_CAMPUS]: 1274,
                [HOUSING_COMMUTER]: 1274
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19159,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2404,
                [HOUSING_OFF_CAMPUS]: 2404,
                [HOUSING_COMMUTER]: 2404
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 19130,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1473,
                [HOUSING_OFF_CAMPUS]: 1473,
                [HOUSING_COMMUTER]: 1473
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3014,
                [HOUSING_OFF_CAMPUS]: 4583,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_UCLA]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 8500,
                [SELF_HELP_RANGE_LOW]: 11000,
                [SELF_HELP_RANGE_HIGH]: 11500
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 718,
                [HOUSING_OFF_CAMPUS]: 718,
                [HOUSING_COMMUTER]: 718
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 18057,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3522,
                [HOUSING_OFF_CAMPUS]: 3522,
                [HOUSING_COMMUTER]: 3522
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18610,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1641,
                [HOUSING_OFF_CAMPUS]: 1641,
                [HOUSING_COMMUTER]: 1641
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3005,
                [HOUSING_OFF_CAMPUS]: 3799,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_MERCED]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 9800,
                [SELF_HELP_RANGE_HIGH]: 9800
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1120,
                [HOUSING_OFF_CAMPUS]: 1120,
                [HOUSING_COMMUTER]: 1120
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 21254,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2492,
                [HOUSING_OFF_CAMPUS]: 2492,
                [HOUSING_COMMUTER]: 2492
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 12999,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1046,
                [HOUSING_OFF_CAMPUS]: 1046,
                [HOUSING_COMMUTER]: 1046
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3191,
                [HOUSING_OFF_CAMPUS]: 4729,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_RIVERSIDE]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 10500,
                [SELF_HELP_RANGE_HIGH]: 14000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1204,
                [HOUSING_OFF_CAMPUS]: 1204,
                [HOUSING_COMMUTER]: 1204
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 20361,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2299,
                [HOUSING_OFF_CAMPUS]: 2299,
                [HOUSING_COMMUTER]: 2299
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 15429,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1576,
                [HOUSING_OFF_CAMPUS]: 1576,
                [HOUSING_COMMUTER]: 1576
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3349,
                [HOUSING_OFF_CAMPUS]: 4874,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SAN_DIEGO]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 10000,
                [SELF_HELP_RANGE_HIGH]: 14000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2281,
                [HOUSING_OFF_CAMPUS]: 2281,
                [HOUSING_COMMUTER]: 2281
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 18110,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2483,
                [HOUSING_OFF_CAMPUS]: 2483,
                [HOUSING_COMMUTER]: 2483
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18404,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1286,
                [HOUSING_OFF_CAMPUS]: 1286,
                [HOUSING_COMMUTER]: 1286
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3163,
                [HOUSING_OFF_CAMPUS]: 4317,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SANTA_BARBARA]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 8940,
                [SELF_HELP_RANGE_LOW]: 11100,
                [SELF_HELP_RANGE_HIGH]: 12720
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1970,
                [HOUSING_OFF_CAMPUS]: 1970,
                [HOUSING_COMMUTER]: 1970
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19712,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3511,
                [HOUSING_OFF_CAMPUS]: 3511,
                [HOUSING_COMMUTER]: 3511
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 17047,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1381,
                [HOUSING_OFF_CAMPUS]: 1381,
                [HOUSING_COMMUTER]: 1381
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3075,
                [HOUSING_OFF_CAMPUS]: 3698,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SANTA_CRUZ]: {
            [SELF_HELP]: {
                [SELF_HELP_DEBT_FREE]: 9186,
                [SELF_HELP_RANGE_LOW]: 12500,
                [SELF_HELP_RANGE_HIGH]: 13500
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 14436,
                [HOUSING_OFF_CAMPUS]: 14436,
                [HOUSING_COMMUTER]: 14436
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1607,
                [HOUSING_OFF_CAMPUS]: 1607,
                [HOUSING_COMMUTER]: 1607
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19662,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3455,
                [HOUSING_OFF_CAMPUS]: 3455,
                [HOUSING_COMMUTER]: 3455
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 19560,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1192,
                [HOUSING_OFF_CAMPUS]: 1192,
                [HOUSING_COMMUTER]: 1192
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3230,
                [HOUSING_OFF_CAMPUS]: 4166,
                [HOUSING_COMMUTER]: 4976
            }
        }
    },
    [RESIDENCY_OTHER]: {
        [CAMPUS_BERKELEY]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 0,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 0
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2086,
                [HOUSING_OFF_CAMPUS]: 2086,
                [HOUSING_COMMUTER]: 2086
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 23544,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 4050,
                [HOUSING_OFF_CAMPUS]: 4050,
                [HOUSING_COMMUTER]: 4050
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18422,
                [HOUSING_COMMUTER]: 7732
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1131,
                [HOUSING_OFF_CAMPUS]: 1131,
                [HOUSING_COMMUTER]: 1131
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3326,
                [HOUSING_OFF_CAMPUS]: 3800,
                [HOUSING_COMMUTER]: 5260
            }
        },
        [CAMPUS_DAVIS]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 300,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 10000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2321,
                [HOUSING_OFF_CAMPUS]: 2321,
                [HOUSING_COMMUTER]: 2321
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19785,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3741,
                [HOUSING_OFF_CAMPUS]: 3741,
                [HOUSING_COMMUTER]: 3741
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 14745,
                [HOUSING_COMMUTER]: 8020
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1386,
                [HOUSING_OFF_CAMPUS]: 1386,
                [HOUSING_COMMUTER]: 1386
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 2977,
                [HOUSING_OFF_CAMPUS]: 3615,
                [HOUSING_COMMUTER]: 4985
            }
        },
        [CAMPUS_IRVINE]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 0,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 0
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1274,
                [HOUSING_OFF_CAMPUS]: 1274,
                [HOUSING_COMMUTER]: 1274
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19159,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0,
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2404,
                [HOUSING_OFF_CAMPUS]: 2404,
                [HOUSING_COMMUTER]: 2404
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 19130,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1473,
                [HOUSING_OFF_CAMPUS]: 1473,
                [HOUSING_COMMUTER]: 1473
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3014,
                [HOUSING_OFF_CAMPUS]: 4583,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_UCLA]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 300,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 20000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 718,
                [HOUSING_OFF_CAMPUS]: 718,
                [HOUSING_COMMUTER]: 718
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 18057,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3522,
                [HOUSING_OFF_CAMPUS]: 3522,
                [HOUSING_COMMUTER]: 3522
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18610,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1641,
                [HOUSING_OFF_CAMPUS]: 1641,
                [HOUSING_COMMUTER]: 1641
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3005,
                [HOUSING_OFF_CAMPUS]: 3799,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_MERCED]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 0,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 0
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1120,
                [HOUSING_OFF_CAMPUS]: 1120,
                [HOUSING_COMMUTER]: 1120
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 21254,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2492,
                [HOUSING_OFF_CAMPUS]: 2492,
                [HOUSING_COMMUTER]: 2492
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 12999,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1046,
                [HOUSING_OFF_CAMPUS]: 1046,
                [HOUSING_COMMUTER]: 1046
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3191,
                [HOUSING_OFF_CAMPUS]: 4729,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_RIVERSIDE]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 3000,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 13500
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1204,
                [HOUSING_OFF_CAMPUS]: 1204,
                [HOUSING_COMMUTER]: 1204
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 20361,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2299,
                [HOUSING_OFF_CAMPUS]: 2299,
                [HOUSING_COMMUTER]: 2299
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 15429,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1576,
                [HOUSING_OFF_CAMPUS]: 1576,
                [HOUSING_COMMUTER]: 1576
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3349,
                [HOUSING_OFF_CAMPUS]: 4874,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SAN_DIEGO]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 0,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 0
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 2281,
                [HOUSING_OFF_CAMPUS]: 2281,
                [HOUSING_COMMUTER]: 2281
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 18110,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 2483,
                [HOUSING_OFF_CAMPUS]: 2483,
                [HOUSING_COMMUTER]: 2483
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 18404,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1286,
                [HOUSING_OFF_CAMPUS]: 1286,
                [HOUSING_COMMUTER]: 1286
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3163,
                [HOUSING_OFF_CAMPUS]: 4317,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SANTA_BARBARA]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 0,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 0
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1970,
                [HOUSING_OFF_CAMPUS]: 1970,
                [HOUSING_COMMUTER]: 1970
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19712,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3511,
                [HOUSING_OFF_CAMPUS]: 3511,
                [HOUSING_COMMUTER]: 3511
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 17047,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1381,
                [HOUSING_OFF_CAMPUS]: 1381,
                [HOUSING_COMMUTER]: 1381
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3075,
                [HOUSING_OFF_CAMPUS]: 3698,
                [HOUSING_COMMUTER]: 4976
            }
        },
        [CAMPUS_SANTA_CRUZ]: {
            [NON_RESIDENT_SCHOLARSHIP]: {
                [NON_RESIDENT_SCHOLARSHIP_LOW]: 3000,
                [NON_RESIDENT_SCHOLARSHIP_HIGH]: 10000
            },
            [COSTS_DIRECT_TUITION]: {
                [HOUSING_ON_CAMPUS]: 48636,
                [HOUSING_OFF_CAMPUS]: 48636,
                [HOUSING_COMMUTER]: 48636
            },
            [COSTS_DIRECT_CAMPUS_FEES]: {
                [HOUSING_ON_CAMPUS]: 1607,
                [HOUSING_OFF_CAMPUS]: 1607,
                [HOUSING_COMMUTER]: 1607
            },
            [COSTS_DIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 19662,
                [HOUSING_OFF_CAMPUS]: 0,
                [HOUSING_COMMUTER]: 0
            },
            [COSTS_DIRECT_HEALTH_INSURANCE]: {
                [HOUSING_ON_CAMPUS]: 3455,
                [HOUSING_OFF_CAMPUS]: 3455,
                [HOUSING_COMMUTER]: 3455
            },
            [COSTS_INDIRECT_HOUSING_AND_MEALS]: {
                [HOUSING_ON_CAMPUS]: 0,
                [HOUSING_OFF_CAMPUS]: 19560,
                [HOUSING_COMMUTER]: 8014
            },
            [COSTS_INDIRECT_BOOKS_AND_SUPPLIES]: {
                [HOUSING_ON_CAMPUS]: 1192,
                [HOUSING_OFF_CAMPUS]: 1192,
                [HOUSING_COMMUTER]: 1192
            },
            [COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION]: {
                [HOUSING_ON_CAMPUS]: 3230,
                [HOUSING_OFF_CAMPUS]: 4166,
                [HOUSING_COMMUTER]: 4976
            }
        }
    }
}